module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"save":"Сохранить"}}')
  delete Component.options._Ctor
}
